import { DEFAULT_COLUMNS_PIPELINES_EXEC, DEFAULT_COLUMNS_PIPELINES_TABS, DEFAULT_COLUMNS_JOBS_EXEC, DEFAULT_COLUMNS_JOBS_TABS, DEFAULT_SCHEDULER_LABELS, PLATFORM_LABEL_MAP, PLATFORM_NAME_TO_ID, DEFAULT_COLUMNS_EXEC, DEFAULT_COLUMNS_WINDOWS_TABS, DEFAULT_COLUMNS_SAP_TABS, DEFAULT_COLUMNS_SQL_TABS, DEFAULT_COLUMNS_SQL_EXEC, DEFAULT_COLUMNS_MDT_DDH_EXEC, DEFAULT_COLUMNS_ADB_TABS, DEFAULT_COLUMNS_ADB_EXEC, PLATFORM_FILTER_DROPDOWN_RULES, DEFAULT_COLUMNS_DDH_TABS, DEFAULT_COLUMNS_MDT_TABS, DEFAULT_COLUMNS_IICS_EXEC } from "components/DataPipeline/constant";

export function getPlatformLabels(platform?: number | string) {
  let platformId: number | undefined;

  if (typeof platform === "string") {
    platformId = PLATFORM_NAME_TO_ID[platform];
  } else if (typeof platform === "number") {
    platformId = platform;
  }

  if (platformId == null) return DEFAULT_SCHEDULER_LABELS;
  return PLATFORM_LABEL_MAP[platformId] || DEFAULT_SCHEDULER_LABELS;
}

export function getDefaultColumnNamesTabs(platform: string | number): string[] {
  let platformId: number | undefined;

  if (typeof platform === "string") {
    platformId = PLATFORM_NAME_TO_ID[platform];
  } else if (typeof platform === "number") {
    platformId = platform;
  }

  if ([1, 2].includes(platformId as number)) return DEFAULT_COLUMNS_JOBS_TABS;
  if (platformId === 3) return DEFAULT_COLUMNS_DDH_TABS;
  if (platformId === 4) return DEFAULT_COLUMNS_PIPELINES_TABS;
  if (platformId === 7) return DEFAULT_COLUMNS_MDT_TABS;
  if (platformId === 8) return DEFAULT_COLUMNS_WINDOWS_TABS;
  if (platformId === 9) return DEFAULT_COLUMNS_SAP_TABS;
  if (platformId === 10) return DEFAULT_COLUMNS_SQL_TABS;
  if (platformId === 11) return DEFAULT_COLUMNS_ADB_TABS;
  if (platformId === 12) return DEFAULT_COLUMNS_SAP_TABS;
  return DEFAULT_COLUMNS_JOBS_TABS;
}

export function getDefaultColumnNamesExec(platform: string | number): string[] {
  let platformId: number | undefined;

  if (typeof platform === "string") {
    platformId = PLATFORM_NAME_TO_ID[platform];
  } else if (typeof platform === "number") {
    platformId = platform;
  }

  if (platformId === 4) return DEFAULT_COLUMNS_PIPELINES_EXEC;
  if (platformId === 8 || platformId === 9) return DEFAULT_COLUMNS_EXEC;
  if (platformId === 12) return DEFAULT_COLUMNS_IICS_EXEC;
  if (platformId === 10) return DEFAULT_COLUMNS_SQL_EXEC;
  if (platformId === 11) return DEFAULT_COLUMNS_ADB_EXEC;
  if (platformId === 3 || platformId === 7) return DEFAULT_COLUMNS_MDT_DDH_EXEC;
  if ([1, 2].includes(platformId as number)) return DEFAULT_COLUMNS_JOBS_EXEC;
  return DEFAULT_COLUMNS_JOBS_EXEC;
}

export function getFilterDropdownConfig(platformName: string) {
  return PLATFORM_FILTER_DROPDOWN_RULES.find(cfg => cfg.platform === platformName);
}

export function getKindFromPlatformId(platformId?: number): 'Job' | 'Pipeline' | '' {
  if (!platformId) return '';

  if (platformId === 4) return 'Pipeline';

  if (PLATFORM_LABEL_MAP[platformId]) return 'Job';

  return '';
}

